import { template } from "@ember/template-compiler";
import { ALL_DAY_SLOT, TIME_SLOTS, WEEKDAYS } from 'client-portal/models/waitlist-intake-form';
import { action } from '@ember/object';
import { concat, fn } from '@ember/helper';
import { on } from '@ember/modifier';
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import Component from '@glimmer/component';
import RequestValidatedInput from 'client-portal/components/request/validated-input';
import styles from './availability-grid.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
const TIME_SLOT_LABEL_KEYS = {
    [ALL_DAY_SLOT]: 'site.waitlistIntake.timeSlots.allDay',
    Morning: 'site.waitlistIntake.timeSlots.morning',
    Afternoon: 'site.waitlistIntake.timeSlots.afternoon',
    Evening: 'site.waitlistIntake.timeSlots.evening'
};
export default class SiteWaitlistIntakeAvailabilityGrid extends Component {
    styles = styles;
    get rows() {
        let availability1 = this.args.availability || {};
        return WEEKDAYS.map((day1)=>{
            let selectedSlots1 = availability1[day1] || [];
            let isAllDaySelected1 = selectedSlots1.includes(ALL_DAY_SLOT);
            return {
                day: day1,
                slots: TIME_SLOTS.map((value1)=>({
                        value: value1,
                        labelKey: TIME_SLOT_LABEL_KEYS[value1],
                        testId: value1.replace(/\s+/g, '-').toLowerCase(),
                        isChecked: selectedSlots1.includes(value1),
                        isDisabled: isAllDaySelected1 && value1 !== ALL_DAY_SLOT
                    }))
            };
        });
    }
    @action
    toggleSlot(day1, slot1, event1) {
        this.args.onToggle?.(day1, slot1, event1.target.checked);
    }
    static{
        template(`
    <div class={{styles.component}}>
      <h2 class="availability-title has-tooltip" id="waitlist-availability-title">
        <span class="required-marker" aria-hidden="true">*</span>
        {{t "site.waitlistIntake.fields.availability"}}
        <span class="tooltip-wrapper" aria-label={{t "shared.accessibility.helpLabel"}}>
          {{svgJar "help" class="icon" aria-hidden="true"}}
          <AttachTooltip @class="tooltip align-left">
            <div>{{t "site.waitlistIntake.tooltips.availability.mornings"}}</div>
            <div>{{t "site.waitlistIntake.tooltips.availability.afternoons"}}</div>
            <div>{{t "site.waitlistIntake.tooltips.availability.evenings"}}</div>
          </AttachTooltip>
        </span>
      </h2>

      <RequestValidatedInput
        @model={{@form}}
        @path="availability"
        @isDirty={{@form.isDirty}}
        data-test-availability
      >
        <div
          class="availability-grid"
          id="waitlist-availability"
          role="group"
          aria-labelledby="waitlist-availability-title"
        >
          {{#each this.rows as |row|}}
            <div class="availability-row" data-test-availability-day={{row.day}}>
              <span class="day-label">{{t (concat "site.waitlistIntake.weekdays." row.day)}}</span>
              {{#each row.slots as |slot|}}
                <label class="boolean slot-checkbox">
                  <input
                    type="checkbox"
                    name="availability-{{row.day}}-{{slot.testId}}"
                    checked={{slot.isChecked}}
                    disabled={{slot.isDisabled}}
                    {{on "change" (fn this.toggleSlot row.day slot.value)}}
                    data-test-availability-slot="{{row.day}}-{{slot.testId}}"
                  />
                  <span class="slot-label">{{t slot.labelKey}}</span>
                </label>
              {{/each}}
            </div>
          {{/each}}
        </div>
      </RequestValidatedInput>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
